import React from 'react';

export const useDelay = (delay: number | null, onTimeout: () => void) => {
  React.useEffect(() => {
    if (delay === null) {
      return;
    }

    const timer = setTimeout(onTimeout, delay);
    return () => clearTimeout(timer);
  }, [delay, onTimeout]);
};
